import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
import { sendPartnerSms } from 'modules/accommodations/features/reservations/api';

export const useSendPartnerSmsMutation = () => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  const { mutate: sendSms, isLoading: isSending } = useMutation(sendPartnerSms, {
    onSuccess: () => successToast(t('SMS sent successfully.')),
    onError: () => errorToast(),
  });

  return {
    isSending,
    sendSms,
  };
};
